import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("trix-file-accept", this.acceptImages)
  }

  disconnect() {
    this.element.removeEventListener("trix-file-accept", this.acceptImages)
  }

  acceptImages = (event) => {
    if (!event.file?.type?.startsWith("image/")) {
      event.preventDefault()
    }
  }
}
